import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

G.createHighscorePanel2ContentManager = function createHighscorePanel2ContentManager(
  game, rewardCoins, stateTracker, animator,
  smallUIParent,
  smallExampleUIComponentFirst,
  smallExampleUIComponentNext,
  largeUIParent,
  largeExampleUIComponentFirst,
  largeExampleUIComponentNext
) {

  // imports
  function getJson(key) { return G.json[key]; }
  var SendableResourceType   = G.HighscorePanel2Data.SendableResourceType;
  //var sendResourceIfPossible = G.HighscorePanel2Data.sendResourceIfPossible;
  var setShownInstant        = G.HighscorePanel2Helper.setShownInstant;

  //

  var DataType = {
    Rating: 'rating',
    Lives:  'lives'
  };

  var ContentGroup = {
    RatingSmall: 'rating_small',
    LivesSmall:  'lives_small',
    RatingLarge: 'rating_large',
    LivesLarge:  'lives_large'
  };

  var currentContentGroup = ContentGroup.RatingSmall;

  var timerUpdatersManager = G.HighscorePanel2Helper.createTimerUpdatersManager(game);

  var avatarsManager = G.HighscorePanel2Helper.createAvatarsManager(
    game,
    game.make.image(0, 0, 'leaderboard2', 'lb2_avatar_mask'),
    stateTracker,
    findMaxAvatarSize()
  );

  var factories = {};
  factories[ContentGroup.RatingSmall] = createRatingSmallFactory(
    smallUIParent, smallExampleUIComponentFirst, smallExampleUIComponentNext, true
  );
  factories[ContentGroup.LivesSmall] = createLivesSmallFactory(
    smallUIParent, smallExampleUIComponentFirst, smallExampleUIComponentNext
  );
  factories[ContentGroup.RatingLarge] = createRatingLargeFactory(
    largeUIParent, largeExampleUIComponentFirst, largeExampleUIComponentNext
  );
  factories[ContentGroup.LivesLarge] = createLivesLargeFactory(
    largeUIParent, largeExampleUIComponentFirst, largeExampleUIComponentNext
  );

  var fabricator = null;

  var datas = {};

  avatarsManager.getFuturePromise(DataType.Rating).promise.then(function() {
    if (!stateTracker.isAlive()) return;
    if (
      currentContentGroup === ContentGroup.RatingSmall ||
      currentContentGroup === ContentGroup.RatingLarge
    ) {
      fabricateFromArray(factories[currentContentGroup], datas[currentContentGroup]);
    }
  });

  avatarsManager.getFuturePromise(DataType.Lives).promise.then(function() {
    if (!stateTracker.isAlive()) return;
    if (
      currentContentGroup === ContentGroup.LivesSmall ||
      currentContentGroup === ContentGroup.LivesLarge
    ) {
      fabricateFromArray(factories[currentContentGroup], datas[currentContentGroup]);
    }
  });

  return {
    ContentGroup: ContentGroup,

    setRatingsData: setRatingsData,
    setLivesData:   setLivesData,

    hideCurrentGroup: hideCurrentGroup,
    showGroup:        showGroup
  };

  //

  function setRatingsData(data) {
    datas[ContentGroup.RatingSmall] = G.HighscorePanel2Data.repositionCurrentPlayerToTop4(data);
    datas[ContentGroup.RatingLarge] = data;
    avatarsManager.tryPreload(DataType.Rating, data.map(function(entry) { return entry.image; }));
  }

  function setLivesData(data) {
    datas[ContentGroup.LivesSmall] = data;
    datas[ContentGroup.LivesLarge] = data;
    avatarsManager.tryPreload(DataType.Lives, data.map(function(entry) { return entry.image; }));
  }

  //

  function hideCurrentGroup() {

    if (fabricator) {
      fabricator.stopFabricating();
      fabricator = null;
    }

    if (currentContentGroup !== null) {
      animator.hide(factories[currentContentGroup].group);

      var contentGroup = currentContentGroup;
      G.AsyncUtils.createScheduler(game, animator.getDuration()).rescheduleAction(function() {
        factories[contentGroup].clear();
      });
      if (currentContentGroup === ContentGroup.LivesLarge) {
        timerUpdatersManager.pauseFrequentUpdate();
      }
    }

    currentContentGroup = null;
  }

  function showGroup(contentGroup) {

    if (contentGroup === ContentGroup.LivesLarge) {
      timerUpdatersManager.resumeFrequentUpdate();
    }

    var dataType;
    switch (contentGroup) {
      case ContentGroup.RatingSmall: dataType = DataType.Rating; break;
      case ContentGroup.LivesSmall:  dataType = DataType.Lives;  break;
      case ContentGroup.RatingLarge: dataType = DataType.Rating; break;
      case ContentGroup.LivesLarge:  dataType = DataType.Lives;  break;
      default: throw new TypeError;
    }
    if (avatarsManager.getFuturePromise(dataType).isSettled()) {
      fabricateFromArray(factories[contentGroup], datas[contentGroup]);
    }
    animator.show(factories[contentGroup].group);

    currentContentGroup = contentGroup;
  }

  //

  function fabricateFromArray(factory, dataList) {
    if (fabricator) {
      fabricator.stopFabricating();
      fabricator = null;
    }
    factory.clear();
    fabricator = G.HighscorePanel2Helper.createFabricator(game, factory, dataList);
    fabricator.startFabricating();
  }

  function findMaxAvatarSize() {
    var maxRect = G.HighscorePanel2Helper.createMaxRect();
    [
      [smallUIParent, smallExampleUIComponentFirst, getJson('ui/leaderboard/lb_entry_small')],
      [largeUIParent, largeExampleUIComponentFirst, getJson('ui/leaderboard/lb_entry_container')]
    ].forEach(function(data) {
      var rect = getAvatarSize(data[0], data[1], data[2]);
      maxRect.expand(rect.width, rect.height);
    });
    return maxRect;

    function getAvatarSize(uiParent, exampleUIComponent, uiElementJsonData) {
      
      var subpart = G.UI.createUIElement(
        game,
        uiElementJsonData,
        exampleUIComponent.desiredSize.x / uiElementJsonData.desiredSize[0],
        exampleUIComponent.desiredSize.y / uiElementJsonData.desiredSize[1],
        getJson
      );

      var positioner = G.HighscorePanel2Helper.createPositioner(
        exampleUIComponent,
        exampleUIComponent
      );
      positioner.position(subpart.rootElement, 0);

      uiParent.add(subpart.rootElement);
      G.UI.resize(
        subpart.rootElement,
        uiParent.customComponents.ui.desiredSize.x,
        uiParent.customComponents.ui.desiredSize.y
      );

      var maxRect = G.HighscorePanel2Helper.createMaxRect();
      subpart.exports.forEvery('avatar', function(element, index, exports) {
        maxRect.expand(element.width, element.height);
      });

      uiParent.removeChild(subpart.rootElement);
      subpart.rootElement.destroy(true);

      return maxRect;
    }
  }

  function createFactory(
    uiParent,
    exampleUIComponentFirst,
    exampleUIComponentNext,
    horizontal,
    uiElementJsonData,
    getExportNamesToSkip,
    initializeUIElementFunc,
    optMakeVisible
  ) {
    var direction    = horizontal ? { x: 1, y:    0 } : { x:    0, y: 1 };
    var scrollAnchor = horizontal ? { x: 0, y: null } : { x: null, y: 0 };

    var positioner = G.HighscorePanel2Helper.createPositioner(
      exampleUIComponentFirst,
      exampleUIComponentNext
    );

    var index = 0;

    var scaleX = exampleUIComponentFirst.desiredSize.x / uiElementJsonData.desiredSize[0];
    var scaleY = exampleUIComponentFirst.desiredSize.y / uiElementJsonData.desiredSize[1];

    var parentUIComponent = uiParent.customComponents.ui;

    var parentDesiredWidth  = parentUIComponent.desiredSize.x;
    var parentDesiredHeight = parentUIComponent.desiredSize.y;
    var subParent = G.UI.createGroup(game, parentDesiredWidth, parentDesiredHeight);
    uiParent.add(subParent);
    G.UI.resize(
      subParent,
      parentUIComponent.sizeAfterLastResize.x,
      parentUIComponent.sizeAfterLastResize.y
    );

    var subParentActualSize = subParent.customComponents.ui.sizeAfterLastResize;

    var scrollManager = G.HighscorePanel2Helper.createScrollManager(
      function getScrollContent() { return scrollContent; },
      subParentActualSize,
      parentUIComponent.desiredSize,
      direction,
      scrollAnchor
    );
    subParent.add(scrollManager.group);

    var scrollContent = G.UI.createGroup(game, parentDesiredWidth, parentDesiredHeight);
    subParent.add(scrollContent);

    if (!optMakeVisible) G.HighscorePanel2Helper.hideInstant(subParent);

    return {
      group: subParent,
      fabricate: fabricate,
      clear: clear
    };

    function clear() {
      index = 0;
      scrollContent.removeAll(true);
    }

    function fabricate(/*arguments*/) {

      var filter = createFilter.apply(null, arguments);

      var subpart = G.UI.createUIElement(game, uiElementJsonData, scaleX, scaleY, getJson, filter);
      
      positioner.position(subpart.rootElement, index);

      ++index;

      scrollContent.add(subpart.rootElement);
      G.UI.resize(
        subpart.rootElement,
        parentUIComponent.desiredSize.x,
        parentUIComponent.desiredSize.y
      );

      var result = initializeUIElementFunc.apply(
        null,
        [subpart].concat(Array.prototype.slice.call(arguments))
      );

      scrollManager.expandToContain(
        subpart.rootElement.customComponents.ui.anchoredLayout,
        parentUIComponent.desiredSize
      );

      return result;
    }

    function createFilter(/*arguments*/) {
      var exportNamesToSkip = getExportNamesToSkip.apply(null, arguments);
      return filter;
      function filter(exportNames) {
        return exportNames.every(function(e) {
          return exportNamesToSkip.indexOf(e) === -1;
        });
      }
    }
  }

  //

  function createRatingLargeFactory(
    uiParent,
    exampleUIComponentFirst,
    exampleUIComponentNext,
    optMakeVisible
  ) {

    return createFactory(
      uiParent,
      exampleUIComponentFirst,
      exampleUIComponentNext,
      false,
      getJson('ui/leaderboard/lb_entry_container'),
      getExportNamesToSkip,
      initializeUIElement,
      optMakeVisible
    );

    function getExportNamesToSkip(leaderboardEntryData, index) {
      var exportNamesToSkip = [
        leaderboardEntryData.isCurrentUser ? 'other_player' : 'current_player',
        'lives'
      ];
      if (index % 2 === 0) exportNamesToSkip.push('background');
      if (leaderboardEntryData.isCurrentUser) exportNamesToSkip.push('coins');
      return exportNamesToSkip;
    }

    function initializeUIElement(subpart, leaderboardEntryData, index) {

      if (!leaderboardEntryData.isCurrentUser) {

        addUpdateVisibilityFunc(
          leaderboardEntryData.id, SendableResourceType.ContextChange,
          subpart.exports, 'coins'
        );

        initButtons(
          subpart.exports, 'button_get_coins',
          function(button) { reactToCoinsButtonClick(leaderboardEntryData.id, button); }
        );

        addAnimation(subpart.exports, 'animate_squish_squash');
      }

      setText(subpart.exports, 'text_place', String(leaderboardEntryData.rank));
      setText(
        subpart.exports, 'text_username',
        shortenedName(leaderboardEntryData.name)
      );
      setText(subpart.exports, 'text_score', leaderboardEntryData.score);

      emplaceAvatar(subpart.exports, 'avatar', leaderboardEntryData.image);

      r2tTaggedElements(subpart.exports, 'r2t');
    }
  }

  function createLivesLargeFactory(
    uiParent,
    exampleUIComponentFirst,
    exampleUIComponentNext,
    optMakeVisible
  ) {

    return createFactory(
      uiParent,
      exampleUIComponentFirst,
      exampleUIComponentNext,
      false,
      getJson('ui/leaderboard/lb_entry_container'),
      getExportNamesToSkip,
      initializeUIElement,
      optMakeVisible
    );

    function getExportNamesToSkip(friendData, index) {
      var exportNamesToSkip = [
        'current_player',
        'text_place',
        'score',
        'coins'
      ];
      if (index % 2 === 0) exportNamesToSkip.push('background');
      return exportNamesToSkip;
    }

    function hijackButtonAndReplace(container, target) {
      let details;
      _.forEach(container.children, (child) => {
        if (child) {
          if (child.name === target) {
            details = {
              x: child.x,
              y: child.y,
            };
            child.destroy();
          }
        }
      });
      if (details) {
        const buttonContainer = new Phaser.Group(game, null);
        const button = new OMT_UI_SquareButton(0, 0, { // Hijack
          button: {
            tint: BUTTONCOLOURS.blue,
            dimensions: {
              width: 196, 
              height: 100,
            },
            extraDetail: false,
            isEnabled: false,
          },
          options: {
            clickFunction: {
              scaleOnClick: false
            },
          },
        });
        buttonContainer.x = details.x; // Place in the same place
        buttonContainer.y = details.y;
        buttonContainer.scale.set(0.7); // Set to size
        buttonContainer.addChild(button);
        container.addChildAt(buttonContainer, 0); // Added it back to the bottom
      }
    }

    function initializeUIElement(subpart, friendData, index) {

      setText(
        subpart.exports, 'text_username',
        shortenedName(friendData.name)
      );


      if (OMT.feature.isGiftingSupported()) { // we dont want these buttons for IOS / non gifting platforms

        addUpdateVisibilityFunc(
          friendData.id, SendableResourceType.LifeShare,
          subpart.exports, 'send_live_active', 'send_live_inactive'
        );
        let container = subpart.exports.getFirst('send_live_inactive')
        if (container) {
          hijackButtonAndReplace(container.rootElement, 'send_live_button_inactive');
        }
        container = null;
  
        addUpdateTimerTextFunc(
          friendData.id, SendableResourceType.LifeShare,
          subpart.exports, 'send_live_timer_text'
        );

        addUpdateVisibilityFunc(
          friendData.id, SendableResourceType.LifeRequest,
          subpart.exports, 'request_live_active', 'request_live_inactive'
        );
        container = subpart.exports.getFirst('request_live_inactive')
        if (container) {
          hijackButtonAndReplace(container.rootElement, 'request_live_button_inactive');
        }
        
  
        addUpdateTimerTextFunc(
          friendData.id, SendableResourceType.LifeRequest,
          subpart.exports, 'request_live_timer_text'
        );

        initButtons(
          subpart.exports, 'button_send_live',
          function(button) { reactToSendLiveButtonClick(friendData.id); }
        );

        initButtons(
          subpart.exports, 'button_request_live', 
          function(button) { reactToRequestLiveButtonClick(friendData.id); }
        );
      } else {
        disableElement(subpart.exports, 'button_send_live');
        disableElement(subpart.exports, 'send_live_active');
        disableElement(subpart.exports, 'send_live_inactive');  
        disableElement(subpart.exports, 'send_live_timer_text');
        disableElement(subpart.exports, 'button_request_live');
        disableElement(subpart.exports, 'request_live_active');
        disableElement(subpart.exports, 'request_live_inactive');
        disableElement(subpart.exports, 'request_live_timer_text');
      }

      emplaceAvatar(subpart.exports, 'avatar', friendData.image);
      r2tTaggedElements(subpart.exports, 'r2t');
    }
  }

  function createRatingSmallFactory(
    uiParent,
    exampleUIComponentFirst,
    exampleUIComponentNext,
    optMakeVisible
  ) {

    return createFactory(
      uiParent,
      exampleUIComponentFirst,
      exampleUIComponentNext,
      true,
      getJson('ui/leaderboard/lb_entry_small'),
      getExportNamesToSkip,
      initializeUIElement,
      optMakeVisible
    );

    function getExportNamesToSkip(leaderboardEntryData, index) {
      var exportNamesToSkip = [
        leaderboardEntryData.isCurrentUser ? 'other_player' : 'current_player',
        'lives'
      ];
      if (leaderboardEntryData.isCurrentUser) exportNamesToSkip.push('coins');

      if (index < 3) {
        exportNamesToSkip.push('placement_low');
        exportNamesToSkip.push('text_placement_low');
      } else {
        exportNamesToSkip.push('text_placement_high');
      }
      if (index !== 0) {
        exportNamesToSkip.push('crown');
        exportNamesToSkip.push('placement_first');
      }
      if (index !== 1) exportNamesToSkip.push('placement_second');
      if (index !== 2) exportNamesToSkip.push('placement_third');
      
      return exportNamesToSkip;
    }

    function initializeUIElement(subpart, leaderboardEntryData, index) {

      if (!leaderboardEntryData.isCurrentUser) {

        addUpdateVisibilityFunc(
          leaderboardEntryData.id, SendableResourceType.ContextChange,
          subpart.exports, 'coins'
        );

        initButtons(
          subpart.exports, 'button_get_coins',
          function(button) { reactToCoinsButtonClick(leaderboardEntryData.id, button); }
        );

        addAnimation(subpart.exports, 'animate_squish_squash');
      }

      setText(subpart.exports, 'text_placement_low',  String(leaderboardEntryData.rank), false);
      setText(subpart.exports, 'text_placement_high', String(leaderboardEntryData.rank), false);
      setText(subpart.exports, 'text_score',          leaderboardEntryData.score);
      setText(
        subpart.exports, 'text_username',
        shortenedName(leaderboardEntryData.name)
      );

      emplaceAvatar(subpart.exports, 'avatar', leaderboardEntryData.image);

      r2tTaggedElements(subpart.exports, 'r2t');
    }
  }

  function createLivesSmallFactory(
    uiParent,
    exampleUIComponentFirst,
    exampleUIComponentNext,
    optMakeVisible
  ) {

    return createFactory(
      uiParent,
      exampleUIComponentFirst,
      exampleUIComponentNext,
      true,
      getJson('ui/leaderboard/lb_entry_small'),
      getExportNamesToSkip,
      initializeUIElement,
      optMakeVisible
    );

    function getExportNamesToSkip(friendData, index) {
      var exportNamesToSkip = [
        'current_player',
        'crown',
        'placement_first',
        'placement_low',
        'text_placement_low',
        'text_placement_high',
        'placement_second',
        'placement_third',
        'score',
        'coins'
      ];
      return exportNamesToSkip;
    }

    function initializeUIElement(subpart, friendData, index) {

      setText(
        subpart.exports, 'text_username',
        shortenedName(friendData.name)
      );

      if (OMT.feature.isGiftingSupported()) { // we dont want these buttons for IOS / non gifting platforms

        addUpdateVisibilityFunc(
          friendData.id, SendableResourceType.LifeShare,
          subpart.exports, 'button_send_live', 'button_send_live_inactive'
        );

        initButtons(
          subpart.exports, 'button_send_live',
          function(button) { reactToSendLiveButtonClick(friendData.id); }
        );
      } else {
        disableElement(subpart.exports, 'button_send_live');
        disableElement(subpart.exports, 'button_send_live_inactive');
      }

      emplaceAvatar(subpart.exports, 'avatar', friendData.image);

      r2tTaggedElements(subpart.exports, 'r2t');
    }
  }

  // Button listeners

  function reactToCoinsButtonClick(friendId, button) {
    if (!OMT.feature.isGiftingSupported() || !G.saveState.canResourceBeSent(friendId, G.HighscorePanel2Data.SendableResourceType.ContextChange)) {
      return;
    }

    OMT.social.sendCoinsMessage(friendId, (success) => {
      if (!success || !stateTracker.isAlive()) return;
      G.saveState.setResourceSentTimestamp(friendId, G.HighscorePanel2Data.SendableResourceType.ContextChange);
      timerUpdatersManager.startTimer(friendId, G.HighscorePanel2Data.SendableResourceType.ContextChange);
      rewardCoins(
        G.json.settings.coinsForChangingContext,
        {
          itemType: G.gift.ItemType.Reward,
          itemId:   G.gift.ItemId.ContextSwitch,
          animateFrom: button.worldPosition
        },
        friendId
      );
    })
  }

  function reactToSendLiveButtonClick(friendId) {
    if (!window.OMT.feature.isGiftingSupported()) {
      return;
    }

    OMT.social.sendLifeMessage(friendId, (success) => {
      if (!success || !stateTracker.isAlive()) return;
      G.saveState.setResourceSentTimestamp(friendId, G.HighscorePanel2Data.SendableResourceType.LifeShare);
      timerUpdatersManager.startTimer(friendId, G.HighscorePanel2Data.SendableResourceType.LifeShare);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.SendLivesHeartClicked);
      OMT.notifications.scheduleGameTriggeredMessage(
        friendId,
        'SentGift',
        1,
        { item: 'a life' },
        false,
      );
    });
  }

  function reactToRequestLiveButtonClick(friendId) {
    if (!window.OMT.feature.isGiftingSupported()) {
      return;
    }
    OMT.social.sendRequestLifeMessage(friendId, (success) => {
      if (!success || !stateTracker.isAlive()) return;
      G.saveState.setResourceSentTimestamp(friendId, G.HighscorePanel2Data.SendableResourceType.LifeRequest);
      timerUpdatersManager.startTimer(friendId, G.HighscorePanel2Data.SendableResourceType.LifeRequest);
      OMT.platformTracking.logEvent(OMT.platformTracking.Events.RequestLivesHeartClicked);
    });
  }

  // Update funcs

  function addUpdateVisibilityFunc(
    userId,
    resourceType,
    exports,
    nameVisibleOnlyOutsideCooldown,
    optNameVisibleOnlyDuringCooldown
  ) {

    timerUpdatersManager.addUpdateFunc(userId, resourceType, onUpdate);

    return;

    function onUpdate(secondsLeft) {

      let shouldHide = secondsLeft > 0; // Should be hidden if cooling down

      if (!window.OMT.feature.isGiftingSupported()) {
        shouldHide = true;
      }

      exports.forEvery(
        nameVisibleOnlyOutsideCooldown,
        function(element, index, exports) { setShownInstant(element, !shouldHide); }
      );

      if (optNameVisibleOnlyDuringCooldown) {
        exports.forEvery(
          optNameVisibleOnlyDuringCooldown,
          function(element, index, exports) { setShownInstant(element, shouldHide); }
        );
      }
    }
  }

  function addUpdateTimerTextFunc(userId, resourceType, exports, name) {

    timerUpdatersManager.addFrequentUpdateFunc(userId, resourceType, onFrequentUpdate);

    return;

    function onFrequentUpdate(secondsLeft) {
      setText(exports, name, G.changeSecToHMS(secondsLeft).join(':'));
    }
  }

  // Helpers

  function setText(exports, name, textValue, optUnavailableBehavior) {
    exports.forEvery(
      name,
      function(textElement, index, exports) { textElement.setText(textValue); },
      optUnavailableBehavior
    );
  }

  function initButtons(exports, name, clickListener) {
    exports.forEvery(
      name,
      function(buttonElement, index, exports) {
        buttonElement.onClick.add(function() { clickListener(buttonElement); });
      }
    );
  }

  function disableElement(exports, name) {
    exports.forEvery(
      name,
      function(element, index, exports) {
        element.visible = false;
        element.x += 10000;
        const parent = element.parent;
        if (parent) parent.removeChild(element);
      }
    );
  }

  function addAnimation(exports, name) {
    exports.forEvery(
      name,
      function(element, index, exports) {
        var animation = G.Animations.Generic.getSquishSquashAnimation(element.scale.x);
        animation.animate(game, element);
      }
    );
  }

  function emplaceAvatar(exports, name, url) {
    exports.forEvery(
      name,
      function(element, index, exports) { avatarsManager.emplaceAvatar(element, url); }
    );
  }

  function r2tTaggedElements(exports, name) {
    exports.forEvery(
      name,
      function(element) { G.HighscorePanel2Helper.r2t(element); }
    );
  }

  function shortenedName(fullName) {
    var matchResult = null;
    if (fullName) {
      matchResult = fullName.match(/^([^\s]*)/);
    }
    var result = matchResult && matchResult[1] || fullName;
    if (result.length > 9) {
      result = result.substr(0, 7) + '...';
    }
    return result;
  }

};
